import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useSocket } from 'cfgCommon/socketContext'
import {
    saveNotifications,
    appendNotifications,
    updateNotificationsList
} from './redux/saveNotifications'
import { NOTIFICATION_SECTION } from './redux/constants'
import { BFFAgent } from 'BFFAgent'
import { toast } from 'react-toastify'
import Menu from '@material-ui/core/Menu'
import NotificationItem from './NotificationItem'
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined'
import IconButton from '@material-ui/core/IconButton'
import Badge from '@material-ui/core/Badge'
import Tooltip from '@material-ui/core/Tooltip'
import Switch from '@material-ui/core/Switch'
import Spinner from 'common/Spinner'
import ConfirmationModal from 'common/ConfirmationModal'
import { checkIsMobile } from 'Utilities'
import emptyBox from 'src/images/empty_box.svg'
import { useHistory } from 'react-router-dom'
import { PushNotifications } from '@capacitor/push-notifications'
import { App as CapacitorApp } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import { FirebaseMessaging } from '@capacitor-firebase/messaging'
import { Badge as AppBadge}  from '@capawesome/capacitor-badge'
import { generateNumericHash } from '../common/utils/generateNumericHash'
import { ERROR_MESSAGES_TEXT } from 'common/Constants'

const EMPTY_NOTIFICATIONS_MESSAGE_ALL = 'Cuando tengas notificaciones leídas las verás acá'
const EMPTY_NOTIFICATIONS_MESSAGE_UNREAD = 'Cuando tengas nuevas las verás acá'
const CLEAR_UNREAD = true

const EmptyNotificationsIcon = () => (
    <svg
        width="64"
        height="65"
        viewBox="0 0 64 65"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M58.0196 32.5002C58.0196 46.8703 46.3701 58.5198 31.9999 58.5198C17.6298 58.5198 5.98071 46.8703 5.98071 32.5002C5.98071 18.13 17.6298 6.48096 31.9999 6.48096C46.3701 6.48096 58.0196 18.13 58.0196 32.5002Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.5077 56.1753C44.8552 56.1753 55.6755 45.355 55.6755 32.0075C55.6755 18.6599 44.8552 7.83963 31.5077 7.83963C18.1602 7.83963 7.33988 18.6599 7.33988 32.0075C7.33988 45.355 18.1602 56.1753 31.5077 56.1753ZM31.5077 58.5921C46.19 58.5921 58.0923 46.6897 58.0923 32.0075C58.0923 17.3252 46.19 5.42285 31.5077 5.42285C16.8254 5.42285 4.9231 17.3252 4.9231 32.0075C4.9231 46.6897 16.8254 58.5921 31.5077 58.5921Z"
            fill="#908AAD"
        />
        <path
            d="M39.7551 21.8924L27.4938 35.3509L22.9412 30.3538L22.9401 30.3525C22.3506 29.7086 21.5375 29.3342 20.6752 29.3365C19.813 29.3388 19.0017 29.7175 18.4153 30.3643L18.9339 30.8345L18.4153 30.3643C17.8308 31.0089 17.5134 31.8692 17.5153 32.7533C17.5173 33.637 17.8383 34.4955 18.4254 35.1371C18.4256 35.1374 18.4258 35.1376 18.426 35.1378L25.1838 42.5554C25.184 42.5556 25.1842 42.5558 25.1844 42.556C25.4752 42.8767 25.8244 43.135 26.2139 43.3127L26.5044 42.6759L26.2139 43.3127C26.6039 43.4907 27.0247 43.5834 27.4516 43.5834C27.8785 43.5834 28.2993 43.4907 28.6893 43.3127C29.0788 43.135 29.4279 42.8767 29.7187 42.5561C29.7189 42.5559 29.7192 42.5556 29.7194 42.5554L44.5893 26.2336C44.5894 26.2335 44.5895 26.2334 44.5896 26.2332C44.8808 25.915 45.1091 25.5404 45.2642 25.1323C45.4193 24.724 45.499 24.2881 45.4999 23.8491C45.5009 23.4101 45.4231 22.9738 45.2699 22.5648C45.1166 22.1558 44.8899 21.7799 44.6 21.4601C44.3099 21.1402 43.9618 20.8823 43.5735 20.7045L43.283 21.3391L43.5735 20.7045C43.1849 20.5267 42.7656 20.4335 42.34 20.4323C41.9145 20.4312 41.4947 20.5222 41.1053 20.698C40.7161 20.8738 40.3667 21.1299 40.0752 21.4484L39.7206 21.8357L39.7551 21.8924Z"
            fill="#D3CBE3"
            stroke="#908AAD"
            strokeWidth="1.4"
        />
    </svg>
)

const CheckIcon = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_3576_9599)">
            <path
                d="M7.50016 13.4998L4.00016 9.99984L2.8335 11.1665L7.50016 15.8332L17.5002 5.83317L16.3335 4.6665L7.50016 13.4998Z"
                fill="#2C872C"
            />
        </g>
        <defs>
            <clipPath id="clip0_3576_9599">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

const StyledMenu = props => {
    const isEmpty = props.notifications && props.notifications.length === 0

    return (
        <Menu
            elevation={2}
            getContentAnchorEl={null}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center'
            }}
            PaperProps={{
                className: isEmpty ? 'paper-empty' : 'paper-notification'
            }}
            {...props}
        />
    )
}

const NotificationMenu = ({closeSideMenu,
    forceCloseNotificationsFlag,
    setForceCloseNotificationsFalse,
    onOpen,
}) => {
    const dispatch = useDispatch()
    const notifications = useSelector(state => state.home.notifications)
    const userId = useSelector(state => state.common.user.id)
    const { socket, SOCKET_EVENTS } = useSocket()
    const [anchorEl, setAnchorEl] = useState(null)
    const [loading, setLoading] = useState(false)
    const [showUnreadOnly, setShowUnreadOnly] = useState(true)
    const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(true)
    const [badgeCount, setBadgeCount] = useState(0)
    const [unreadCount, setUnreadCount] = useState(0)
    const [readCount, setReadCount] = useState(0)
    const [badgeVisible, setBadgeVisible] = useState(true)
    const [forceShow, setForceShow] = useState(false)
    const [pendingData, setPendingData] = useState({})
    const notificationIconRef = useRef(null)
    const [showTooltip, setShowTooltip] = useState(false)
    const isMobile = checkIsMobile()
    const shouldUpdateNotificationsList = useSelector(
        (state) => state.home.shouldUpdateNotificationsList
    )
    const history = useHistory()
    const isMobileSystem = useSelector(state => state.common.user.isMobileSystem)
    useEffect(() => {
        const savedShowUnreadOnly = localStorage.getItem('showUnreadOnly')
        if (savedShowUnreadOnly !== null) {
            setShowUnreadOnly(savedShowUnreadOnly === 'true')
        }
    }, [])

    useEffect(()=>{
        if (forceCloseNotificationsFlag){
            setAnchorEl(null)
            setForceCloseNotificationsFalse()
        }
    }, [forceCloseNotificationsFlag])

    const openNotifications = () => {
        if (onOpen) onOpen()
        setAnchorEl(document.getElementById('notification-icon'))
        setBadgeVisible(false) // Ocultar el badge al abrir el menú
        getNotifications(1, showUnreadOnly)
        setPage(1) // Reiniciar la página a 1 cuando se cambia el filtro

        // Asegurarse de que el scroll esté arriba
        const menuNode = document.querySelector('.paper-notification')
        if (menuNode) {
            menuNode.scrollIntoView()  
        }
        isMobile && closeSideMenu()
    }

    const handleNotification = async () => {
        if(!anchorEl) setLoading(true)
        try {
            const response = await BFFAgent.Notifications.getNotifications(
                userId,
                1,
                showUnreadOnly,
                NOTIFICATION_SECTION.GENERAL
            )
            const { notifications: responseNotifications, totalRead, totalUnread } = response
            if (!anchorEl) {
                dispatch(saveNotifications(responseNotifications))
                initializeNotifications(totalRead, totalUnread)
            } else {
                setPendingData({ notifications: responseNotifications, totalRead, totalUnread })
                setForceShow(true)
            }

            if (totalUnread >= unreadCount) {
                if (anchorEl) {
                    setForceShow(true)
                    setBadgeVisible(false)
                } else {
                    setBadgeVisible(true)
                }
                setBadgeCount(totalUnread)
            }
        } catch (error) {
            if (error.message !== ERROR_MESSAGES_TEXT.forceUpdate && isMobileSystem) {
                toast.error(`Notificaciones: ${BFFAgent.Notifications.getRequestFailedToastMessage(error)}`)
            }
        } finally {
            setLoading(false)
        }
    }

    // Función para eliminar las clases `Mui-focusVisible` y `MuiTouchRipple-root`
    const removeFocusStyles = () => {
        if (notificationIconRef.current) {
            notificationIconRef.current.blur()

            // Eliminar clase Mui-focusVisible
            notificationIconRef.current.classList.remove('Mui-focusVisible')

            // Eliminar el span con la clase MuiTouchRipple-root
            const rippleElement = notificationIconRef.current.querySelector('.MuiTouchRipple-root')
            if (rippleElement) {
                rippleElement.remove()
            }
        }
    }
    
    const handleClose = () => {
        setAnchorEl(null)
        removeFocusStyles()
        setShowTooltip(false)
        if (forceShow) {
            setTimeout(() => {
                setForceShow(false)
                setBadgeVisible(true)
                dispatch(saveNotifications(pendingData.notifications))
                initializeNotifications(pendingData.totalRead, pendingData.totalUnread)
            }, 400)
        }
    }

    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === 'Escape' && anchorEl) {
                handleClose()
            }
        }

        document.addEventListener('keydown', handleEscKey)
        return () => {
            document.removeEventListener('keydown', handleEscKey)
        }
    }, [anchorEl])

    const initializeNotifications = (totalRead, totalUnread) => {
        setReadCount(totalRead)
        setUnreadCount(totalUnread)
        if (badgeVisible && totalUnread > 0) {
            setBadgeCount(totalUnread) 
        }
    }

    const getNotifications = useCallback(
        async (pageToLoad = 1, unreadOnly = showUnreadOnly) => {
            setLoading(true)
            try {
                const response = await BFFAgent.Notifications.getNotifications(
                    userId,
                    pageToLoad,
                    unreadOnly,
                    NOTIFICATION_SECTION.GENERAL
                )
                const { notifications: notificationsResponse, totalRead, totalUnread } = response
                if (pageToLoad === 1) {
                    dispatch(saveNotifications(notificationsResponse))
                } else {
                    dispatch(appendNotifications(notificationsResponse))
                }
                setHasMore(notificationsResponse.length === 12)
                if (pageToLoad === 1) initializeNotifications(totalRead, totalUnread)
            } catch (error) {
                if (error.message !== ERROR_MESSAGES_TEXT.forceUpdate && isMobileSystem) {
                    toast.error(`Notificaciones: ${BFFAgent.Notifications.getRequestFailedToastMessage(error)}`)
                }
            } finally {
                setLoading(false)
            }
        },
        [userId, showUnreadOnly, dispatch, badgeVisible, shouldUpdateNotificationsList]
    )

    useEffect(() => {
        getNotifications(1, showUnreadOnly) 
    }, [])

    useEffect(() => {
        if (socket) {
            socket.on(SOCKET_EVENTS.NOTIFICATION, handleNotification)
             return () => {
                socket.off(SOCKET_EVENTS.NOTIFICATION, handleNotification)
            }
        }
    }, [
        socket,
        SOCKET_EVENTS,
        userId,
        dispatch,
        showUnreadOnly,
        unreadCount,
        anchorEl
    ])

    const removeDeliveredPushNotification = async notificationId => {
        try {
            const hashedNotificationId = generateNumericHash(notificationId).toString()
            let activeNotifications = await PushNotifications.getDeliveredNotifications()
            // First condition its for Android -> the push notification doesnt got our id
            // Second condition its for iOS -> the push notifications does got our id
            const pushNotificationToRemove = activeNotifications.notifications.find(
                n => n.tag === hashedNotificationId || (n.data && n.data.notification_id === notificationId)
            )

            if (pushNotificationToRemove) {
                await PushNotifications.removeDeliveredNotifications({
                    notifications: [pushNotificationToRemove]
                })
            }

            activeNotifications = await PushNotifications.getDeliveredNotifications()
            const unreadQuantity = activeNotifications.notifications.length 
            
            if (unreadQuantity === 0) {
                AppBadge.clear()
            } else {
                AppBadge.set({ count: unreadQuantity })
            }
        } catch (error) {
            console.error('Error al intentar limpiar la notificacion push de la bandeja', error)
        }
    }

    const handleMarkAsRead = async notificationId => {
        try {
            await BFFAgent.Notifications.markAsRead(notificationId, userId)
            // Modificar la notificación localmente para evitar un nuevo fetch
            const notificationIndex = notifications.findIndex(notification => notification.id === notificationId)
            const updatedNotifications = [...notifications]
            updatedNotifications[notificationIndex] = { ...updatedNotifications[notificationIndex], read: true }
            
            const filteredNotifications = showUnreadOnly
                ? updatedNotifications.filter(notification => !notification.read)
                : updatedNotifications

            dispatch(saveNotifications(filteredNotifications))
            setUnreadCount(unreadCount - 1)
            setBadgeCount(badgeCount - 1)

            if (unreadCount === 1) {
                setBadgeVisible(false)
            }
            if (isMobileSystem) removeDeliveredPushNotification(notificationId)
        } catch (error) {
            toast.error('Error al marcar la notificación como leída')
        }
    }

    useEffect(() => {
        if (isMobileSystem) {
            const setupChannel = async () => {
                try {
                    const channel = {
                        id: 'asofix_default_channel',
                        name: 'Notificaciones de Asofix',
                        description: 'Notificaciones de app Asofix',
                        // TODO -> llevar a constants
                        importance: 5, // Define máxima prioridad para no ser tomada como spam
                        visibility: 1, // Permite que se visualice en cualquier pantalla
                        sound: 'default',
                    }

                    await PushNotifications.createChannel(channel)
                } catch (error) {
                    console.error('Error al crear el canal de notificación', error)
                }
            }
            
            // They are 2 listeners with the same function tapListener
            // With this wrapper function, only one call will reach the bd and update unread_push_notifications
            const withDeduplication = (callback) => {
                const processedIds = new Set()

                return (event) => {
                    const data = event.notification?.data || event?.data || {}
                    const notificationId = data.notification_id || event.notification?.id || 'unknown'

                    if (processedIds.has(notificationId)) return

                    processedIds.add(notificationId)
                    setTimeout(() => {
                        processedIds.delete(notificationId)
                    }, 2000)

                    callback(event, data)
                }
            }

            const handleTapLogic = (event, data) => {
                const url = data.redirect_url
                const notificationId = data.notification_id
                
                if (url) history.push(url)
                if (notificationId) handleMarkAsRead(notificationId)
                
                BFFAgent.User.updateUnreadPushNotifications(userId)
                AppBadge.decrease()
            }

            const tapListener = withDeduplication(handleTapLogic)

            const regenerateNotifications = async (state) => {
                if (state.isActive) {
                    handleNotification()
                    try {
                        const activeNotifications = await PushNotifications.getDeliveredNotifications()
                        const unreadQuantity = activeNotifications.notifications.length
                        if (unreadQuantity === 0) {
                            BFFAgent.User.updateUnreadPushNotifications(userId, CLEAR_UNREAD)
                            AppBadge.clear()
                        }
                        else {
                            BFFAgent.User.updateUnreadPushNotifications(userId, !CLEAR_UNREAD, unreadQuantity)
                            AppBadge.set({ count: unreadQuantity })
                        }
                    }
                    catch (error) {
                        toast.error('Error al querer actualizar el badge de la aplicacion')
                    }
                    
                }
            }

            if (Capacitor.getPlatform() === 'android') setupChannel()
            const listenerPromises = [
                PushNotifications.addListener('pushNotificationActionPerformed', tapListener),
                FirebaseMessaging.addListener('notificationActionPerformed', tapListener),
                PushNotifications.addListener('pushNotificationReceived', handleNotification),
                FirebaseMessaging.addListener('notificationReceived', handleNotification),
                CapacitorApp.addListener('appStateChange', regenerateNotifications)
            ]
        
            return () => {
                Promise.all(listenerPromises)
                    .then((promises) => promises.forEach(promise => promise?.remove()))
            }
        }
    }, [])
    
    

    const handleMarkAsUnread = async (notificationId) => {
        try {
          await BFFAgent.Notifications.markAsUnread(notificationId, userId)
            // Modificar la notificación localmente para evitar un nuevo fetch
            
            const notificationIndex = notifications.findIndex(notification => notification.id === notificationId)
            const updatedNotifications = [...notifications]
            updatedNotifications[notificationIndex] = { ...updatedNotifications[notificationIndex], read: false }

            dispatch(saveNotifications(updatedNotifications))
            setUnreadCount(unreadCount + 1)
            setBadgeCount(unreadCount + 1)
        } catch (error) {
          toast.error('Error al marcar la notificación como no leída')
        }
      }

    const handleScroll = useCallback(() => {
        const menuNode = isMobile ? document.querySelector('.notifications-mobile-container') : document.querySelector('.paper-notification')
        if (!menuNode || loading || !hasMore) return

        const { scrollTop, scrollHeight, clientHeight } = menuNode
        if (scrollHeight - scrollTop <= clientHeight + 20) {
            const nextPage = page + 1
            getNotifications(nextPage, showUnreadOnly)
            setPage(nextPage)
        }
    }, [loading, hasMore, page, getNotifications])

    useEffect(() => {
        const menuNode = isMobile ? document.querySelector('.notifications-mobile-container') : document.querySelector('.paper-notification')
        if (menuNode) {
            menuNode.addEventListener('scroll', handleScroll)
        }
        return () => {
            if (menuNode) {
                menuNode.removeEventListener('scroll', handleScroll)
            }
        }
    }, [handleScroll])

    const handleSwitchChange = () => {
        const newShowUnreadOnly = !showUnreadOnly
        setShowUnreadOnly(newShowUnreadOnly)
        localStorage.setItem('showUnreadOnly', newShowUnreadOnly) // Guardar preferencia en localStorage
        setPage(1) // Reiniciar la página a 1 cuando se cambia el filtro
        setHasMore(true) // Restablecer hasMore cuando se cambia el filtro
        dispatch(saveNotifications([])) // Limpiar notificaciones para evitar confusión visual
        getNotifications(1, newShowUnreadOnly) // Obtener notificaciones según el nuevo estado del switch
    }

    const displayedNotifications = Array.isArray(notifications)
        ? notifications
        : []
    useEffect(async () => {
        if (shouldUpdateNotificationsList) {
            const response = await BFFAgent.Notifications.getNotifications(
                userId,
                1,
                showUnreadOnly,
                NOTIFICATION_SECTION.GENERAL
            )
            dispatch(updateNotificationsList(false))
            const { notifications: responseNotifications, totalRead, totalUnread } = response
            setReadCount(totalRead)
            dispatch(saveNotifications(responseNotifications))
            initializeNotifications(totalUnread)
            if ((totalUnread > unreadCount || totalUnread == unreadCount) && !anchorEl) {
                setBadgeVisible(true)
                setBadgeCount(totalUnread)
            }
        }
    }, [shouldUpdateNotificationsList])

    const renderEmptyNotifications = () => {
        const allReadMessage = <>
            <EmptyNotificationsIcon />
            <div className="empty-state-title">
                Estás al día
            </div>
            <div className="empty-state-text">
                Ya leíste todas las notificaciones de los últimos 15
                días
            </div>
        </>

        const emptyMessage = <>
            <img src={emptyBox} alt="Imagen por defecto" />
            <div className="empty-state-title">
                Aún no tenés notificaciones
            </div>
            <div className="empty-state-text">
                {
                    showUnreadOnly ? EMPTY_NOTIFICATIONS_MESSAGE_UNREAD : EMPTY_NOTIFICATIONS_MESSAGE_ALL
                }
            </div>
        </>

        return <div className="empty-state-notification">
            {
                readCount == 0 ? emptyMessage : allReadMessage
            }
        </div>
    }

    const renderNotificationList = () => {
        return (
            <>
                <div className="notification-header">
                    {!isMobile && <span className="title-notification">Notificaciones</span>}
                    <div className="notification-filter">
                        <span>Mostrar sólo las no leídas</span>
                        <Switch
                            checked={showUnreadOnly}
                            onChange={handleSwitchChange}
                            color="primary"
                            disabled={loading}
                        />
                    </div>
                </div>
                <div className="notification-list">
                    {loading && page === 1 ? (
                        <div className="loading-state-notification">
                            <div className="spinner">
                                <Spinner colorIcon="#6c63ff" centered={true} />
                            </div>
                            <div className="loading-text">
                                Cargando notificaciones...
                            </div>
                        </div>
                    ) : displayedNotifications.length ? (
                        displayedNotifications.map(notification => (
                            <NotificationItem
                                key={notification.id}
                                notification={notification}
                                onMarkAsRead={handleMarkAsRead}
                                onMarkAsUnread={handleMarkAsUnread}
                                closeMenu={handleClose}
                            />
                        ))
                    ) : renderEmptyNotifications()}
                </div>

                {notifications.length > 0 && !loading && !hasMore && (
                    <>
                        <hr className="notification-divider" />
                        <div className="notification-footer">
                            <CheckIcon className="check-icon" />
                            <span>
                                Estas son todas las notificaciones{' '}
                                {showUnreadOnly ? <b>no leídas </b> : ''} de los
                                últimos 15 días
                            </span>
                        </div>
                    </>
                )}
                {loading && page > 1 && (
                    <div className="loading-more">
                        <Spinner colorIcon="#6c63ff" centered={true} />
                    </div>
                )}
            </>
        )
    }

    return (
        <div className="home-notification-menu">
            <Tooltip
                title={`Notificaciones`}
                placement="bottom"
                arrow
                ref={notificationIconRef}
                open={showTooltip && !anchorEl}
                disableHoverListener
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
            >
                <IconButton
                    color="inherit"
                    onClick={anchorEl ? handleClose : openNotifications}
                    id="notification-icon"
                >
                    {badgeVisible && badgeCount > 0 ? (
                        <Badge
                            badgeContent={badgeCount > 9 ? '9+' : badgeCount}
                            color="error"
                        >
                            <NotificationsIcon />
                        </Badge>
                    ) : (
                        <NotificationsIcon />
                    )}
                </IconButton>
            </Tooltip>
            {Boolean(anchorEl) && 
                isMobile?
                    <ConfirmationModal
                        title='Notificaciones'
                        overlayClassName='notifications-mobile-container'
                        className='notifications-mobile-inner-container'
                        footerClassName='mobile-footer'
                        onClose={() => handleClose()}
                    >
                        {renderNotificationList()}
                    </ConfirmationModal>
                :
                    <StyledMenu
                    id="notifications"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    >
                        {renderNotificationList()}
                    </StyledMenu>
            }
        </div>
    )
}

export default NotificationMenu
